import { SVGProps } from "react";

const FaqsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_5477_33939)">
      <path
        d="M16.5625 5.22596C17.1458 5.55763 17.5042 6.17846 17.5 6.84929V12.9193C17.5 13.5935 17.1308 14.2151 16.535 14.5426L10.91 18.101C10.6311 18.2541 10.3181 18.3343 10 18.3343C9.68186 18.3343 9.36887 18.2541 9.09 18.101L3.465 14.5426C3.17347 14.3833 2.9301 14.1486 2.76034 13.863C2.59058 13.5775 2.50067 13.2515 2.5 12.9193V6.84846C2.5 6.17429 2.86917 5.55346 3.465 5.22596L9.09 1.90929C9.37711 1.75099 9.69964 1.66797 10.0275 1.66797C10.3554 1.66797 10.6779 1.75099 10.965 1.90929L16.59 5.22596H16.5625Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5625 5.22596C17.1458 5.55763 17.5042 6.17846 17.5 6.84929V12.9193C17.5 13.5935 17.1308 14.2151 16.535 14.5426L10.91 18.101C10.6311 18.2541 10.3181 18.3343 10 18.3343C9.68186 18.3343 9.36887 18.2541 9.09 18.101L3.465 14.5426C3.17347 14.3833 2.9301 14.1486 2.76034 13.863C2.59058 13.5775 2.50067 13.2515 2.5 12.9193V6.84846C2.5 6.17429 2.86917 5.55346 3.465 5.22596L9.09 1.90929C9.37711 1.75099 9.69964 1.66797 10.0275 1.66797C10.3554 1.66797 10.6779 1.75099 10.965 1.90929L16.59 5.22596H16.5625Z"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 13.332V13.342"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 13.332V13.342"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 10.8331C10.3748 10.8343 10.739 10.709 11.0339 10.4777C11.3287 10.2463 11.537 9.9223 11.625 9.55799C11.7131 9.19369 11.6758 8.81034 11.5191 8.46985C11.3625 8.12937 11.0956 7.85162 10.7617 7.68147C10.4301 7.51165 10.0509 7.45899 9.68567 7.53207C9.32043 7.60515 8.99066 7.79966 8.75 8.08397"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 10.8331C10.3748 10.8343 10.739 10.709 11.0339 10.4777C11.3287 10.2463 11.537 9.9223 11.625 9.55799C11.7131 9.19369 11.6758 8.81034 11.5191 8.46985C11.3625 8.12937 11.0956 7.85162 10.7617 7.68147C10.4301 7.51165 10.0509 7.45899 9.68567 7.53207C9.32043 7.60515 8.99066 7.79966 8.75 8.08397"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5477_33939">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default FaqsIcon;
